<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">Translations DB</a>
    <div id="navbarSupportedContent" class="collapse navbar-collapse">
      <ul class="navbar-nav ml-auto">
        <li v-if="userLoggedIn" class="nav-item active">
          <router-link to="/languages" 
                       class="nav-link">Languages</router-link>
        </li>
        <li v-if="userLoggedIn" class="nav-item">
          <router-link to="/groups" 
                       class="nav-link">Groups</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/translations" 
                       class="nav-link">Translations</router-link>
        </li>
        <li v-if="userLoggedIn" class="nav-item active">
          <router-link to="/backups" 
                       class="nav-link">Backups</router-link>
        </li>
        <li v-if="userLoggedIn" class="nav-item active">
          <router-link to="/adduser" 
                       class="nav-link">Add User</router-link>
        </li>
        <li v-if="!userLoggedIn" class="nav-item">
          <router-link to="/login" 
                       class="nav-link">Login</router-link>
        </li>
        <li v-if="userLoggedIn" class="nav-item">
          <a class="nav-link text-danger" 
             href="#" 
             @click="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase';
import { mapMutations, mapGetters, } from 'vuex';

export default {
	name: 'Navbar',
	components: {},
	data: () => {
		return {
			meta: null,
		};
	},
	computed: {
    ...mapGetters(['userLoggedIn',]),
	},
	created() {
		this.meta = this.$route.meta;
	},
	methods: {
    ...mapMutations(['logoutUser',]),
		logout() {
			firebase
				.auth()
				.signOut()
				.then(() => {
					this.logoutUser();
					this.$router.replace('/login');
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue